import {
  REMERCHANDISE_FAILED,
  REMERCHANDISE_START,
  REMERCHANDISE_SUCCESS,
  RemerchCreateStore,
  RemerchCreateAction,
  RESET_REMERCHANDISE
} from './types';

const initialState = {  createPending: true,
  loading: false,
  response: null,
  error: null};

export const remerchCreate = (
  state: RemerchCreateStore = {
    createPending: true,
    loading: false,
    response: null,
    error: null
  },
  action: RemerchCreateAction
): RemerchCreateStore => {
  switch (action.type) {
    case REMERCHANDISE_START:
      return { createPending: true, loading: true, response: null, error: null };
    case REMERCHANDISE_SUCCESS: {
      return {
        createPending: false,
        loading: false,
        response: action.payload,
        error: null
      };
    }
    case REMERCHANDISE_FAILED: {
      return {
        createPending: true,
        loading: false,
        error: action.payload
      };
    }
    case RESET_REMERCHANDISE:
      return initialState;
    default:
      return state;
  }
};
